/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, tier: NonNullable<unknown>, percent: NonNullable<unknown> }} Report_Partner_TieredInputs */



/**
* | output |
* | --- |
* | "Partner: {name} · {tier}, {percent} off list on seats and copilot · net amounts" |
*
* @param {Report_Partner_TieredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_partner_tiered = /** @type {((inputs: Report_Partner_TieredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Partner_TieredInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Partner: ${i?.name} · ${i?.tier}, ${i?.percent} unter Liste auf Plätze und Copilot · Nettobeträge`)
	return /** @type {LocalizedString} */ (`Partner: ${i?.name} · ${i?.tier}, ${i?.percent} off list on seats and copilot · net amounts`)
});